/**
 * @file 公共请求服务入口
 * @date 2022-06-21 12:43:20
 */
import request from '@@/utils/request';

// 获取新闻主页面列表
export const news = () => {
  return request('news');
};

// 获取所有最新新闻,按照发布时间倒序
export const newsByAll = (offset, limit) => {
  return request('news', {
    offset,
    limit,
  });
};

export const newsBySection = (section, offset, limit) => {
  return request('news', {
    section,
    offset,
    limit,
  });
};

// 获取视频列表 key为空按时间排序 key 为数字 按照key 随机排序
export const videoList = ({ key, offset, limit } = {}) => {
  return request('video', {
    key,
    offset,
    limit,
  });
};

// 获取壁纸列表 key为空按时间排序 key 为数字 按照key 随机排序
// t1 t2 表示类型枚举 为空表示全部
export const pictureList = ({ key, offset, limit, t1, t2 } = {}) => {
  return request('picture', {
    key,
    offset,
    limit,
    t1,
    t2: JSON.stringify(t2 || []),
  });
};
// 获取壁纸列表 key为空按时间排序 key 为数字 按照key 随机排序
// t1 表示角色
export const mmdList = ({ key, offset, limit, t1 } = {}) => {
  return request('mmd', {
    key,
    offset,
    limit,
    t1: JSON.stringify(t1 || []),
  });
};
